module.exports = __webpack_public_path__ + "img/Banner_dashboard 1.57cf57c2.svg";